import classnames from "classnames";
import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import { useRef, useCallback } from "react";
import Link from "next/link";

export default function ChannelCard(props) {
  const { item, intersect, ...props_ } = props;
  const cardRef = useRef();
  const { classNames } = useSliderPosition(props_, cardRef);

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      ref={cardRef}
      className={classnames(classNames, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <Link href={routes.channelDetail(item.id)} onClick={handleClick}>

        <div>
          <CardArtwork item={item} intersect={intersect} />
          <div className={styles.infoContainer}>
            <div className={styles.info}>
              <div className={styles.title}>
                <p>{item.name}</p>
              </div>
            </div>
            <div className={`${styles.feature} ${styles.info}`}>
              {props_.focusIndex != null && (
                <>
                  <div className={styles.title}>
                    <p>{item.name}</p>
                  </div>
                  <div className={styles.genre}>
                    {item.genres.map((genre) => genre.name).join("/")}
                  </div>
                  <div className={styles.description}>
                    <p>{item.description}</p>
                  </div>
                  <div className={styles.other}>
                    <span></span>
                    <FavoriteButton
                      metaId={item.id}
                      className={styles.favorite}
                      fillGray
                      scale
                      text="お気に入り"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

      </Link>
    </div>
  );
}
